<template>
  <div v-if="visible" ref="confirm" class="cp-confirm mobile">
    <div class="box-mask">
      <div class="box-container" :class="{hasChance: hasChance}">
        <div class="prize"></div>
        <div class="prize-wrapper">
          <Prize
            v-for="(item, index) in prize"
            :key="index"
            :prize="item.icon"
            :name="item.name || item.title"
            :class="`prize prize-${index + 1}`"
          >
          </Prize>
        </div>
        <div class="button">
          <div class="bottom-item confirm" @click="handleAction('yes')"></div>
          <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prize from "~/components/Prize/index.vue";
import Close from '~/components/Close/close.vue';
// import { mapState } from "vuex";
export default {
  name: 'Confirm',
  components: {Prize, Close},
  data() {
    return {
      visible: false,
      prize: [],
      prizeList: {list: []},
      promiseStatus: null
    }
  },
  computed: {
    hasChance() {
      let hasChance = !this.prizeList || !this.prizeList.list || this.prizeList.list.length < 50
      return hasChance
    }
  },
  methods: {
    confirm() {
      let _this = this;
      this.visible = true;
      return new Promise(function(resolve, reject) {
        _this.promiseStatus = { resolve, reject };
      });
    },
    handleAction(action) {
      this.$refs.confirm.className += ' fadeOut';
      let t = setTimeout(() => {
        this.visible = false;
        clearTimeout(t);
        if (action === 'yes') {
          this.promiseStatus && this.promiseStatus.resolve('ok');
        } else {
          this.promiseStatus && this.promiseStatus.reject('cancel');
        }
      }, 300);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cp-confirm{
    text-align: center;
    color: #2c3e50;
    height: 100%;
    font-size: .32rem;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index 2001
    top 0
    animation fadeIn 0.3s ease-in-out
    &.fadeOut {
      animation fadeOut 0.3s ease-in-out
      animation-fill-mode forwards
    }
    .box-mask{
      z-index: 900;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .box-container {
    position absolute
    width 6.92rem
    height 7.41rem
    top 50%
    left 0.29rem
    margin-top -3.705rem
    background-image url('./images/modal.png')
    background-size: contain;
    background-repeat: no-repeat;
    background-position 0 0
    animation fadeIn 0.3s ease-in-out
    &.hasChance {
      background-image url('./images/modal1.png')
    }
    .prize-wrapper {
      margin 1.9rem 0 0 0.58rem
      position relative
      display flex
      flex-wrap wrap
    }
    .button {
      width 5.07rem
      height 0.8rem
      margin: 0.46rem auto 0
      .bottom-item {
        width 2.27rem
        height 0.8rem
        background-image url('./images/confirm.png')
        background-size: 2.27rem 0.8rem;
        background-repeat: no-repeat;
        display inline-block
        &.cancel {
          margin-left 0.53rem
          background-image url('./images/cancel.png')
        }
      }
    }
  }
  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
